import { ChartSubType } from '@g17eco/types/insight-custom-dashboard';

export const NA_NR_CHART_SUBTYPES = [
  ChartSubType.SingleValue,
  ChartSubType.SparkLine,
  ChartSubType.FullPie,
  ChartSubType.Pie,
  ChartSubType.PieWithLegend,
  ChartSubType.Line,
  ChartSubType.Column,
  ChartSubType.Stacked,
  ChartSubType.Bar,
];

export const FULL_DATA_NA_NR_SUBTYPES = [
  ChartSubType.SparkLine,
  ChartSubType.Line,
  ChartSubType.Column,
  ChartSubType.Stacked,
];
